var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { QueryCondition } from './QueryCondition';
import { Result } from '../model/Result';
import { DataError, DataErrorType } from '../model/Error/DataError';
import { BaseDatabase } from './BaseDatabase';
import { JSApi } from '../tools/JSApi';
import { wrapResult } from '../tools/utils';
import { OfflineData } from '../model/OfflineData';
import { Log } from '../tools/Log';
var BEACON_EVENT_CODE = 'client_data_base_performance';
var ClientDatabase = /** @class */ (function (_super) {
    __extends(ClientDatabase, _super);
    function ClientDatabase(options) {
        return _super.call(this, options) || this;
    }
    ClientDatabase.isValidResponse = function (response) {
        if (typeof response === 'object') {
            return true;
        }
        return false;
    };
    ClientDatabase.prototype.init = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            var req = {
                command: 'init',
                table: _this._tables,
                dbName: _this._dbName
            };
            JSApi.invokeNative('docx', 'clientDatabaseRequest', req, function (res) {
                if (res.err_msg || res.err_code) {
                    var error = new Error(res.err_msg || res.err_code);
                    resolve(new Result(error));
                }
                else {
                    resolve(new Result(undefined, undefined));
                }
                _this.reportBeacon(BEACON_EVENT_CODE, start, req, res);
            });
        });
    };
    ClientDatabase.prototype.set = function (tableName, data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            var req = {
                command: 'set',
                tableName: tableName,
                data: data,
                dbName: _this._dbName
            };
            JSApi.invokeNative('docx', 'clientDatabaseRequest', req, function (res) {
                if (res.err_msg || res.err_code) {
                    var error = new Error(res.err_msg || res.err_code);
                    resolve(new Result(error));
                }
                else {
                    resolve(new Result(undefined, res.result));
                }
                _this.reportBeacon(BEACON_EVENT_CODE, start, req, res);
            });
        });
    };
    ClientDatabase.prototype.update = function (tableName, data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            var req = {
                command: 'update',
                tableName: tableName,
                data: data,
                dbName: _this._dbName
            };
            JSApi.invokeNative('docx', 'clientDatabaseRequest', req, function (res) {
                if (res.err_msg || res.err_code) {
                    var error = new Error(res.err_msg || res.err_code);
                    resolve(new Result(error));
                }
                else {
                    resolve(new Result(undefined, res.result));
                }
                _this.reportBeacon(BEACON_EVENT_CODE, start, req, res);
            });
        });
    };
    /**
     * 增量更新内容
     * @param tableName 表名
     * @param where 条件查询
     * @param toBeUpdated 要更新的字段和数据
     */
    ClientDatabase.prototype.updateField = function (tableName, where, toBeUpdated) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            var req = {
                command: 'updateField',
                tableName: tableName,
                where: where,
                toBeUpdated: toBeUpdated,
                dbName: _this._dbName
            };
            JSApi.invokeNative('docx', 'clientDatabaseRequest', req, function (res) {
                if (res.err_msg || res.err_code) {
                    var error = new Error(res.err_msg || res.err_code);
                    resolve(new Result(error));
                }
                else {
                    resolve(new Result(undefined, res.result));
                }
                _this.reportBeacon(BEACON_EVENT_CODE, start, req, res);
            });
        });
    };
    ClientDatabase.prototype.updateMultiTableData = function (multiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            var req = {
                command: 'updateMultiTableData',
                multiData: multiData,
                dbName: _this._dbName
            };
            JSApi.invokeNative('docx', 'clientDatabaseRequest', req, function (res) {
                if (res.err_msg || res.err_code) {
                    var error = new Error(res.err_msg || res.err_code);
                    resolve(new Result(error));
                }
                else {
                    resolve(new Result(undefined, res.result));
                }
                _this.reportBeacon(BEACON_EVENT_CODE, start, req, res);
            });
        });
    };
    ClientDatabase.prototype.delete = function (tableName, where) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            var req = {
                command: 'delete',
                tableName: tableName,
                where: where,
                dbName: _this._dbName
            };
            JSApi.invokeNative('docx', 'clientDatabaseRequest', req, function (res) {
                if (res.err_msg || res.err_code) {
                    var error = new Error(res.err_msg || res.err_code);
                    resolve(new Result(error));
                }
                else {
                    resolve(new Result(undefined, res.result));
                }
                _this.reportBeacon(BEACON_EVENT_CODE, start, req, res);
            });
        });
    };
    ClientDatabase.prototype.deleteAndWrite = function (tableName, where, newData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            var req = {
                command: 'deleteAndWrite',
                tableName: tableName,
                where: where,
                newData: newData,
                dbName: _this._dbName
            };
            JSApi.invokeNative('docx', 'clientDatabaseRequest', req, function (res) {
                if (res.err_msg || res.err_code) {
                    var error = new Error(res.err_msg || res.err_code);
                    resolve(new Result(error));
                }
                else {
                    resolve(new Result(undefined, res.result));
                }
                _this.reportBeacon(BEACON_EVENT_CODE, start, req, res);
            });
        });
    };
    /**
     * 单条查询
     * @param tableName
     * @param where
     * @param onSuccess
     * @param onError
     */
    ClientDatabase.prototype.get = function (tableName, where) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var start = Date.now();
                        var req = {
                            command: 'get',
                            tableName: tableName,
                            where: where,
                            dbName: _this._dbName
                        };
                        JSApi.invokeNative('docx', 'clientDatabaseRequest', req, function (res) {
                            if (res.err_msg || res.err_code) {
                                var error = new Error(res.err_msg || res.err_code);
                                resolve(new Result(error));
                            }
                            else if (res.result) {
                                resolve(new Result(undefined, res.result));
                            }
                            else {
                                resolve(new Result(new DataError(DataErrorType.NO_RESULT_ERROR, '没有找到符合条件的内容')));
                            }
                            _this.reportBeacon(BEACON_EVENT_CODE, start, req, res);
                        });
                    })];
            });
        });
    };
    /**
     * 多条查询内容
     * @param tableName
     * @param where 所有条件都是“与”关系
     * @param onSuccess
     * @param onError
     */
    ClientDatabase.prototype.getAll = function (tableName, where) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            var req = {
                command: 'getAll',
                tableName: tableName,
                where: where,
                dbName: _this._dbName
            };
            JSApi.invokeNative('docx', 'clientDatabaseRequest', req, function (res) {
                if (res.err_msg || res.err_code) {
                    var error = new Error(res.err_msg || res.err_code);
                    resolve(new Result(error));
                }
                else {
                    resolve(new Result(undefined, res.result || []));
                }
                _this.reportBeacon(BEACON_EVENT_CODE, start, req, res);
            });
        });
    };
    /**
     * 上报灯塔
     * @param eventCode
     * @param req
     * @param res
     * @param start
     */
    ClientDatabase.prototype.reportBeacon = function (eventCode, start, req, res) {
        try {
            if (window.beaconHandler) {
                window.beaconHandler.onUserAction(eventCode, {
                    tableName: req.tableName || '',
                    command: req.command || '',
                    dbName: req.dbName || '',
                    error_msg: res.err_msg || '',
                    consume_time: Date.now() - start,
                    event_result: res.err_code || 0,
                    cost: Date.now() - start,
                    resultCode: res.err_code || 0,
                });
            }
        }
        catch (error) {
            Log.error(error);
        }
    };
    __decorate([
        wrapResult(OfflineData, 'OfflineData') // 针对OfflineData表的查询，对结果进行对象化
        ,
        wrapResult(OfflineData, 'DocumentData') // 针对DocumentData表的查询，对结果进行对象化
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, QueryCondition]),
        __metadata("design:returntype", Promise)
    ], ClientDatabase.prototype, "get", null);
    __decorate([
        wrapResult(OfflineData, 'OfflineData') // 针对OfflineData表的查询，对结果进行对象化
        ,
        wrapResult(OfflineData, 'DocumentData') // 针对DocumentData表的查询，对结果进行对象化
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, QueryCondition]),
        __metadata("design:returntype", void 0)
    ], ClientDatabase.prototype, "getAll", null);
    return ClientDatabase;
}(BaseDatabase));
export { ClientDatabase };
//# sourceMappingURL=ClientDatabase.js.map